module.exports = __webpack_public_path__ + "static/img/consumidorgov.ec65090.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/consumidorgov.svg
// module id = 1810
// module chunks = 1